export { default } from './SampleDataNotice';
